import Vue from 'vue'
import Vuex from 'vuex'
import { settings } from '@/variables.js'
import axios from 'axios'
import { teamModule } from './modules/team.module'
import { projectsModule } from './modules/projects.module'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menu: null
  },
  mutations: {
    setMenu (state, menu) {
      state.menu = menu
    }
  },
  actions: {
    getMenu (context, menu) {
      axios
        .get(settings.jsonUrl + 'menus/v1/menus/' + menu)
        .then(response => {
          context.commit('setMenu', response.data)
        })
        .catch(error => console.log(error))
    }
  },
  modules: {
    teamModule,
    projectsModule
  }
})
